import React, { useContext, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import Header from "../Layout/Header";
import useBreakPoints from "../hooks/useBreakPoints";
import Loader from "../Component/Loader";
import Sidebar from "../Layout/Sidebar";
import MobileSidebar from "../Layout/MobileSidebar";
const AuthProtected = () => {
  const { isLaptop, isTablet } = useBreakPoints();
  const { token, theme, isMenuExpanded } = useContext(MyContext);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Render child routes here using Outlet
  return (
    <>
      <div
        data-bs-theme={theme === "dark" ? "dark" : "light"}
        data-assets-path="../../assets/"
        data-template="horizontal-menu-template"
        className="layout-compact layout-menu-fixed body"
      >
        <div
          className={`layout-wrapper layout-navbar-full layout-horizontal layout-without-menu ${
            isMenuExpanded ? "layout-menu-expanded" : ""
          }`}
          id="pageWrapper"
        >
          <div className="layout-container">
            <div className="content-wrapper w-100">
              <Outlet />
              {location?.pathname !== "/manage-slot" && <MobileSidebar />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const AccessRoute = ({ component: Component }) => {
  // Render the passed component as a JSX element
  return <>{Component}</>;
};

export { AuthProtected, AccessRoute };
